import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiRequestsService } from '../../services/api-requests.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { DataManipulateService } from '../../services/data-manipulate.service';
import { CommonFunctionService } from '../../services/common-function.service';
import { loginModel } from '../../Interface/login';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  providers: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public model: loginModel = { loginId: 'omkar', password: 'Omkar@123', devType: 'M' };
  showPassword: boolean = false;
  errorEmployeeid: string = '';
  errorPassword: string = '';
  errorMsg: string = '';
  inputType: string = 'password';
  constructor(private route: Router, private apiRequests: ApiRequestsService,
    private toaster: ToastrService, private data: DataManipulateService,
    private common: CommonFunctionService) {
    this.apiRequests.setUnAutorisedHandler(this.common.unAuthorizedHandlerFunction);
  }
  login = async () => {
    this.errorEmployeeid = '';
    this.errorPassword = '';
    this.errorMsg = '';
    this.apiRequests.setUnAutorisedHandler(this.common.unAuthorizedHandlerFunction);
    if (!window.navigator.onLine) {
      this.toaster.error('No Internet Connection');
    } else if (!this.model.loginId && !this.model.password) {
      this.errorMsg = 'Please Enter LoginId and Password';
    } else if (!this.model.loginId) {
      this.errorEmployeeid = 'Please enter Login Id';
    } else if (!this.model.password) {
      this.errorPassword = 'Please enter password';
    } else {
      const { errorCode, errorDescription, Data } = await this.apiRequests.postAPICallWithPromise('user/userLogin', this.model);
      if (errorCode == this.apiRequests.NO_ERROR) {
        this.apiRequests.updateOrSetTokenValue(Data.ntk);
        this.data.userInfo = Data.userInfo;
        // this.toaster.success(errorDescription);
        this.route.navigate(['/dataTable']);
      } else {
        this.errorMsg = errorDescription;
        this.toaster.error(errorDescription);
      }
    }
  };

  passwordVisibility() {
    this.showPassword = !this.showPassword;
    this.inputType = (this.showPassword) ? 'text' : 'password';
  }

  ngOnInit(): void {
  }

  goToPage(route: string) {
    this.route.navigateByUrl(route)
  }

}
